var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.data)}})]),_c('div',{staticClass:"btn",on:{"click":_vm.onClickButton}},[_vm._v("我要报名")])])}
var staticRenderFns = []

export { render, staticRenderFns }